export default __webpack_public_path__ + "static/media/withdrawal-ico.5269abb3.webp";